import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { PosTerminalDetail } from "../../../components/Pages/Catalogs/Posterminal/PosTerminalDetail";
import PosTerminalList from "../../../components/Pages/Catalogs/Posterminal/PosTerminalList";
import { NFLookupPosTerminal } from "../../../components/Shared/NewForms/NFLookupPosTerminal";
import { CreatePosTerminalDto } from "../../../dtos/catalogs/PosTerminal/CreatePosTerminalDto";
import { PosTerminalService } from "../../../services/catalogs/PosTerminalService";

export const PosTerminal: IAppEntity = {
  entityType: "catalog",
  title: "PosTerminal",
  pluralTitle: "PosTerminal",
  apiUrl: "PosTerminals",
  apiEnum: ReferenceTypes.CatalogPosTerminal,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(PosTerminalDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(PosTerminalList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupPosTerminal, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new PosTerminalService(this.apiUrl);
  },
  getEmptyModel(): CreatePosTerminalDto {
    return {
      name: "",
      createdDate: new Date(),
      uniqueCode: "",
    };
  },
};
